(() => {
  const nav = document.getElementById('nav');
  if (nav && document.body.classList.contains('template-index')) {
    const updateNav = () => nav.classList.toggle('is-scrolled', window.scrollY > 36);
    updateNav();
    window.addEventListener('scroll', updateNav, { passive: true });
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const selector = form.querySelector('[data-variant-select]');
    const button = form.querySelector('[data-add-button]');
    const price = form.closest('[data-product-root]')?.querySelector('[data-product-price]');
    const availability = form.closest('[data-product-root]')?.querySelector('[data-product-availability]');
    if (!selector || !button) return;

    const variants = JSON.parse(form.querySelector('[data-variants-json]')?.textContent || '[]');
    selector.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === selector.value);
      if (!variant) return;
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (price) price.textContent = variant.price;
      if (availability) availability.textContent = variant.inventory;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });
})();
